import { z } from "zod";

/**
 * GET /api/v2/inquiries/new-leads — a lightweight, poll-friendly projection
 * of inquiries still sitting in stage "new" (i.e. unactioned). There is no
 * separate seen-flag: once staff moves a lead out of "new", it drops off
 * this list on the next fetch, which is the signal the LEAD-2 alert system
 * uses to quiet down (see src/features/leads).
 */
export const NewLeadSchema = z.object({
  id: z.string(),
  contact_name: z.string().nullable(),
  event_type: z.string().nullable(),
  event_date: z.string().nullable(),
  guest_count: z.number().nullable(),
  venue_name: z.string().nullable(),
  budget_band: z.string().nullable(),
  source: z.string().nullable(),
  message: z.string().nullable(),
  created_at: z.string(),
});
export type NewLead = z.infer<typeof NewLeadSchema>;

export const NewLeadsResponseSchema = z.object({
  count: z.number(),
  leads: z.array(NewLeadSchema),
});
export type NewLeadsResponse = z.infer<typeof NewLeadsResponseSchema>;
